import React from "react";
import styled from "styled-components";

export default styled.div`
    width: 793px;
    min-height: 546px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 52px;
    box-sizing: border-box;
    background: white;
    box-shadow: 0 0 25px #0000005c;
    max-height: calc(100% - 20px);
    overflow-y: scroll;
    position: absolute;
    z-index: 99;
    display: none;

    ${(props) => (props.open ? {
    'display': 'block'
} : '')}
`;